import { EntityChanged, RelodeApiError } from "@relode/core";
import {
    ActionsUnion,
    createAction,
} from "@relode/core/components/reducer/actionHelpers";
import { IClientProfile } from "../../../shared/types/profile/IClientProfile";
export enum settingsActionNames {
    SETTINGS_FETCH = "SETTINGS_FETCH",
    SETTINGS_FETCH_FAILURE = "SETTINGS_FETCH_FAILURE",
    SETTINGS_FETCH_SUCCESS = "SETTINGS_FETCH_SUCCESS",

    SETTINGS_SAVE = "SETTINGS_SAVE",
    SETTINGS_SAVE_FAILURE = "SETTINGS_SAVE_FAILURE",
    SETTINGS_SAVE_SUCCESS = "SETTINGS_SAVE_SUCCESS",

    SETTINGS_TOGGLE_ALERTS = "SETTINGS_TOGGLE_ALERTS",
    SETTINGS_TOGGLE_ALERTS_FAILURE = "SETTINGS_TOGGLE_ALERTS_FAILURE",
    SETTINGS_TOGGLE_ALERTS_SUCCESS = "SETTINGS_TOGGLE_ALERTS_SUCCESS",

    SET_CURRENT_TAB = "SET_CURRENT_TAB",
    SET_CONTACT_CHANGED = "SET_CONTACT_CHANGED",
}

export const creators = {
    fetchSettings: () => createAction(settingsActionNames.SETTINGS_FETCH),
    fetchSettingsSuccess: (client: IClientProfile) =>
        createAction(settingsActionNames.SETTINGS_FETCH_SUCCESS, { client }),
    fetchSettingsFailure: (error: RelodeApiError) =>
        createAction(settingsActionNames.SETTINGS_FETCH_FAILURE, { error }),

    saveSettings: () => createAction(settingsActionNames.SETTINGS_SAVE),
    saveSettingsSuccess: () =>
        createAction(settingsActionNames.SETTINGS_SAVE_SUCCESS),
    saveSettingsFailure: (error: RelodeApiError) =>
        createAction(settingsActionNames.SETTINGS_SAVE_FAILURE, { error }),

    toggleAlerts: () =>
        createAction(settingsActionNames.SETTINGS_TOGGLE_ALERTS),
    toggleAlertsSuccess: () =>
        createAction(settingsActionNames.SETTINGS_TOGGLE_ALERTS_SUCCESS),
    toggleAlertsFailure: (error: RelodeApiError) =>
        createAction(settingsActionNames.SETTINGS_TOGGLE_ALERTS_FAILURE, {
            error,
        }),
    setCurrentTab: (tab: string) =>
        createAction(settingsActionNames.SET_CURRENT_TAB, { tab }),
    setContactChanged: (changed: EntityChanged<IClientProfile>) =>
        createAction(settingsActionNames.SET_CONTACT_CHANGED, {
            changed,
        }),
};

export type SettingsActionTypes = ActionsUnion<typeof creators>;
